class ProductGridCount extends window.BAO.CustomElement({
  SuperClass: HTMLParagraphElement,
}) {
  constructor () {
    super()

    switch (this.dataset.type) {
      case 'search':
        this.eventBus = window.theme.searchResults.eventBus
        this.state = {
          root: window.theme.searchResults?.stateLayer?.state || {
            products: [],
          },
          observer: null,
        }
        break
      case 'autocomplete':
        this.eventBus = window.theme.autocompleteResults.eventBus
        this.state = {
          root: window.theme.autocompleteResults?.stateLayer?.state || {
            products: [],
          },
          observer: null,
        }
        break
      default:
        // Default is collection
        this.eventBus = window.theme.category.eventBus
        this.state = {
          root: window.theme.category?.stateLayer?.state || { products: [] },
          observer: null,
        }
    }
  }

  connectedCallback () {
    this.subscribeToEvents()

    this.setAttribute('hidden', 'true')
    this.textContent = `${this.totalProducts} products`
  }

  subscribeToEvents () {
    this.eventBus.subscribe('state:totalProducts:updated', () => {
      this.textContent = `${this.totalProducts} ${window.theme.strings.collection.products}`
      this.removeAttribute('hidden')
      this.renderViewDependantOnResults()
    })
  }

  renderViewDependantOnResults () {
    if (window.theme.searchResults) {
      const resultsHeader = document.querySelector('.clc-ResultsHeader')
      const noResultsHeader = document.querySelector('.clc-NoResultsHeader')
      const productGrid = document.querySelector('.clc-ProductGrid')

      if (this.totalProducts === 0) {
        resultsHeader.setAttribute('hidden', 'true')
        noResultsHeader.removeAttribute('hidden')
        productGrid.setAttribute('hidden', 'true')
        document.body.classList.add('lyt-KlevuOpen')
      } else {
        resultsHeader.removeAttribute('hidden')
        noResultsHeader.setAttribute('hidden', 'true')
        productGrid.removeAttribute('hidden')
        document.body.classList.remove('lyt-KlevuOpen')
      }
    }
  }

  get totalProducts () {
    return this.state.root.totalProducts || 0
  }
}

customElements.define('product-grid-count', ProductGridCount, {
  extends: 'p',
})
